module.exports = __webpack_public_path__ + "img/profile-back.33e468a.jpg";